<template>
  <div id="boothDesignLog">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'boothDesignLog'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/log/booth/BoothDesignLog.vue